import { Outlet } from 'react-router-dom';

import { SandboxProvider } from '@/providers';

export const GameLayout = () => {
  return (
    <SandboxProvider>
      <Outlet />
    </SandboxProvider>
  );
};
